"use client";

import { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stagesEn = [{
  label: "01 / R&D.",
  title: "Concept to technical blueprint.",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/factory_interior_photo.png?v=xhgg4ap2z59",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/factory_interior_photo.png?v=98l5w0lyqet-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/factory_interior_photo.png?v=rxh6jp8pzdp-wvc-sizes",
  alt: "Engineers reviewing technical product blueprints in a clean office environment.",
  body: "Our R&D team transforms your initial sketches into production-ready technical specifications. We focus on material selection, structural integrity, and cost-optimization, ensuring every design is ready for high-volume manufacturing without compromising on quality."
}, {
  label: "02 / Tooling.",
  title: "Precision mold engineering.",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/cert_badge_5.png?v=f544xrq76b",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/cert_badge_5.png?v=qn1qqvvr3rp-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/cert_badge_5.png?v=oytmgkf0ze-wvc-sizes",
  alt: "CNC machine carving a high-precision steel mold for plastic injection.",
  body: "We develop custom steel molds in-house to ensure exact tolerances. Whether for complex plastic injection or intricate plush patterns, our tooling department guarantees consistency across every unit, reducing waste and accelerating the production cycle."
}, {
  label: "03 / Production.",
  title: "Scalable factory assembly.",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide21_photo_3.png?v=9whh3f036r8",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide21_photo_3.png?v=idjmo7q47c8-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide21_photo_3.png?v=huons72qar-wvc-sizes",
  alt: "Automated assembly line in a modern manufacturing facility.",
  body: "Operating two dedicated factories for plastic and plush, we manage end-to-end production. Our facilities are equipped with modern machinery and managed by experienced teams, ensuring that your products meet global standards for durability and finish."
}, {
  label: "04 / Compliance.",
  title: "Rigorous quality assurance.",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide20_photo_1.png?v=ft56mps4m4",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide20_photo_1.png?v=n4y12fo00wa-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide20_photo_1.png?v=71jw81nxye-wvc-sizes",
  alt: "Quality control technician testing product safety in a certified laboratory.",
  body: "Safety is our priority. We partner with BV, ITS, SGS, and TUV to conduct comprehensive compliance testing. From CCC to G-Mark certifications, we ensure your products are fully compliant with international market regulations before they leave our facility."
}];
const stagesZh = [{
  label: "01 / 研發與設計。",
  title: "從概念到技術藍圖。",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/factory_interior_photo.png?v=xhgg4ap2z59",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/factory_interior_photo.png?v=98l5w0lyqet-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/factory_interior_photo.png?v=rxh6jp8pzdp-wvc-sizes",
  alt: "工程師在整潔的辦公環境中審閱產品技術藍圖。",
  body: "我們的研發團隊將您的初始草圖轉化為可量產的技術規格。我們專注於材料選擇、結構強度及成本優化，確保每項設計在不妥協品質的前提下實現大規模高效製造。"
}, {
  label: "02 / 模具工程。",
  title: "高精密模具工程。",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/cert_badge_5.png?v=f544xrq76b",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/cert_badge_5.png?v=qn1qqvvr3rp-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/cert_badge_5.png?v=oytmgkf0ze-wvc-sizes",
  alt: "數控機床為塑膠注塑雕刻高精度鋼模。",
  body: "我們在廠內自主開發客製化鋼模以確保精確公差。無論是複雜的塑膠注塑還是精細的毛絨版型，我們的模具部門都能保證每件產品的一致性，減少浪費並加快生產週期。"
}, {
  label: "03 / 生產製造。",
  title: "規模化廠房組裝生產。",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide21_photo_3.png?v=9whh3f036r8",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide21_photo_3.png?v=idjmo7q47c8-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide21_photo_3.png?v=huons72qar-wvc-sizes",
  alt: "現代化製造廠房中的自動化組裝流水線。",
  body: "我們運營兩家專門的塑膠與毛絨製造工廠，管理端到端完整生產流程。廠房配備現代化機械設備並由資深團隊管理，確保您的產品在耐用度與精細度上均符合全球嚴格標準。"
}, {
  label: "04 / 品質與合規。",
  title: "嚴格的品質保證。",
  image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide20_photo_1.png?v=ft56mps4m4",
  srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide20_photo_1.png?v=n4y12fo00wa-wvc-srcset",
  sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/production_slide20_photo_1.png?v=71jw81nxye-wvc-sizes",
  alt: "質檢技術員在認證實驗室中進行產品安全檢測。",
  body: "安全是我們的重中之重。我們與 BV、ITS、SGS 和 TUV 等國際權威機構合作進行全面合規測試。從 CCC 到 G-Mark 認證，我們確保產品在出廠前完全符合各國際市場的法規標準。"
}];
function StageRow({
  stage,
  index
}: {
  stage: (typeof stagesEn)[number];
  index: number;
}) {
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const text = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div data-index={index} className="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-10 md:gap-y-0 items-center">
      <div ref={image.ref} className="md:col-span-8 transition-all duration-[900ms] ease-out" style={{
      opacity: image.isVisible ? 1 : 0,
      transform: image.isVisible ? "translateY(0)" : "translateY(12px)",
      transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
    }}>
        <div className="aspect-[3/2] overflow-hidden bg-secondary">
          <img src={stage.image} data-wvc-srcset={stage.srcset} data-wvc-sizes={stage.sizes} alt={stage.alt} loading="lazy" decoding="async" className="object-cover !h-[350px] !w-[600px]" />
        </div>
      </div>

      <div ref={text.ref} className="md:col-span-4 md:pl-2 transition-opacity duration-[700ms] ease-out" style={{
      opacity: text.isVisible ? 1 : 0,
      transitionDelay: text.isVisible ? "100ms" : "0ms"
    }}>
        <div className="text-[0.75rem] font-medium text-foreground font-mono uppercase tracking-[0.15em]">
          {stage.label}
        </div>
        <h3 className="mt-6 font-default text-foreground text-[clamp(1.25rem,2vw,1.5rem)] font-semibold leading-[1.4]" style={{
        letterSpacing: "-0.01em"
      }}>
          {stage.title}
        </h3>
        <p className="mt-6 font-default text-foreground text-[1rem] leading-[1.6]">
          {stage.body}
        </p>
      </div>
    </div>;
}
export default function Manufacturing() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    }
  }, []);
  const stages = isZh ? stagesZh : stagesEn;
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const lede = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="12454" id="manufacturing-infrastructure" className="bg-background text-foreground py-32 md:py-44">
      <div className="mx-auto max-w-[1440px] px-10 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-8 md:items-end">
          <div ref={header.ref} className="md:col-span-8 transition-opacity duration-[700ms] ease-out" style={{
          opacity: header.isVisible ? 1 : 0
        }}>
            <h2 className="font-default text-foreground font-semibold text-[clamp(1.8rem,3.5vw,2.8rem)] leading-[1.2]" style={{
            letterSpacing: "-0.02em"
          }}>
              {isZh ? <>
                  我們的
                  <span className="font-default italic font-normal">
                    生產製造
                  </span>
                  基礎設施。
                </> : <>
                  {"Our industrial "}
                  <span className="font-default italic font-normal">
                    infrastructure
                  </span>
                  .
                </>}
            </h2>
          </div>

          <div ref={lede.ref} className="md:col-span-4 transition-all duration-[900ms] ease-out" style={{
          opacity: lede.isVisible ? 1 : 0,
          transform: lede.isVisible ? "translateY(0)" : "translateY(12px)",
          transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
        }}>
            <p className="font-default text-foreground text-[1.25rem] leading-[1.6]">
              {isZh ? "Elite Group Corporation Limited 提供完善的一站式端到端製造生態系統。從早期研發到最終合規檢測，我們確保您的產品達到全球最高品質標準。" : "Elite Group Corporation Limited provides a seamless, end-to-end manufacturing ecosystem. From initial R&D to final compliance testing, we ensure your products meet the highest global standards."}
            </p>
          </div>
        </div>

        <div className="mt-32 md:mt-32 flex flex-col gap-24 md:gap-24">
          {stages.map((stage, i) => <StageRow key={i} stage={stage} index={i} />)}
        </div>
      </div>
    </section>;
}